export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/bafcb97f65150dd63b7cabadb0e0f790.svg";